// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ProfilePage_overlayWrapper__qpztS"};